import type { PiletApi } from '@chess/platform-web';
import { ENGINE_API, type Engine } from '@chess/api-engine';
import { createUciEngine } from '@chess/api-engine/uci';
import { createWorkerTransport } from './worker-transport';
// Stockfish 19, the lite single-threaded build (GPL-3.0): runs under any
// server, no cross-origin isolation needed. The multithreaded build is the
// upgrade once the host sets COOP/COEP headers.
import glueUrl from '../node_modules/stockfish/bin/stockfish-19-lite-single.js?url';
import wasmUrl from '../node_modules/stockfish/bin/stockfish-19-lite-single.wasm?url';

// Provides `engine` with Stockfish in a Worker. The engine runs as a
// separate process spoken to over UCI text, which keeps the GPL at this
// boundary; nothing else imports the stockfish package.
export function setup(app: PiletApi) {
  let engine: Engine | undefined;
  const get = () => (engine ??= createUciEngine(createWorkerTransport(glueUrl, wasmUrl), { threads: 1 }));

  // Start lazily: the Worker and its 1.8 MB download begin on first use, not on load.
  const lazy: Engine = {
    info: () => get().info(),
    analyse: (position, options) => get().analyse(position, options),
    evaluate: (position, options) => get().evaluate(position, options),
    stop: () => (engine ? engine.stop() : Promise.resolve()),
    dispose: async () => {
      await engine?.dispose();
      engine = undefined;
    },
  };
  app.registerApi(ENGINE_API, lazy);
}
